// @flow

import * as React from 'react';
import {FormattedMessage, MessageDescriptor} from 'react-intl';

type FormattedMessageOrStringProps = {|
  stringOrDefineMessage: string | MessageDescriptor,
|};

export const FormattedMessageOrString = (
  props: FormattedMessageOrStringProps,
) => {
  const stringOrDefineMessage = props.stringOrDefineMessage;

  if (typeof stringOrDefineMessage === 'string') {
    return stringOrDefineMessage;
  } else {
    return (
      <FormattedMessage
        {...stringOrDefineMessage.message}
        values={stringOrDefineMessage.values}
      />
    );
  }
};
